module.exports = __webpack_public_path__ + "static/media/doTERRA-live-guide.9540a8eb.pdf";